const defaultProps = {
  elevation: 0
};

export default defaultProps;
